import { graphql } from '@/gql';
import type { CallRecordingUrlQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchCallRecordingUrl = async ({ callLogId, callSid }: CallRecordingUrlQueryVariables) => {
  const response = await queryExecute({
    variables: {
      callLogId,
      callSid,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query callRecordingUrl($callLogId: Float, $callSid: String) {
        callRecordingUrl(callLogId: $callLogId, callSid: $callSid)
      }
    `),
  });

  return response.data.callRecordingUrl ?? '';
};
